module.exports = __webpack_public_path__ + "static/excellerator-press-release-e270d8e86aff7de35935ba80b9e2977f.pdf";